"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const entity_1 = require("../type/entity");
function getContentType(content) {
    const modelType = content.modelType;
    switch (modelType) {
        case 'offer':
            switch (content.offerType) {
                case 'course':
                    return entity_1.ContentType.COURSE;
                case 'learningCard':
                    return entity_1.ContentType.LEARNING_CARD;
                case 'section':
                    return entity_1.ContentType.SECTION;
                case 'assignmentCard':
                    return entity_1.ContentType.ASSIGNMENT_CARD;
                case 'cardQuestion':
                    return entity_1.ContentType.CARD_QUESTION;
                case 'peerReviewCard':
                    return entity_1.ContentType.PEER_REVIEW_CARD;
                case 'cardQuestionForReview':
                    return entity_1.ContentType.CARD_QUESTION_FOR_REVIEW;
                case 'peerQuestion':
                    return entity_1.ContentType.PEER_QUESTION;
            }
            break;
        case 'curriculumOffer':
            return entity_1.ContentType.CURRICULUM;
        case 'channel':
            return entity_1.ContentType.CHANNEL;
        case 'channelCard':
            return entity_1.ContentType.CHANNEL_CARD;
        case 'activity':
            switch (content.activityType) {
                case 'skill':
                    return entity_1.ContentType.SKILL;
                case 'checkpoint':
                    return entity_1.ContentType.CHECKPOINT;
                case 'liveTraining':
                    return entity_1.ContentType.ILT;
                case 'liveTrainingSession':
                    return entity_1.ContentType.ILT_SESSION;
            }
            break;
        default:
            console.info('Incorrect modelType found in getContentType', modelType);
            throw new Error('Incorrect modelType found in getContentType' + modelType);
    }
    return entity_1.ContentType.GENERIC;
}
exports.getContentType = getContentType;
//# sourceMappingURL=getContentType.js.map